import type { StreamElement, TurboStreamActions } from "@hotwired/turbo";

function refresh_data_grid(this: StreamElement) {
  const dataGridId: string | null = this.getAttribute("id");
  if (!dataGridId) return;

  const el = document.getElementById(dataGridId) as any;
  if (!el) return;

  (window as any).Alpine?.$data(el)?.refreshDataGrid?.();
}

export function registerDataGridActions(streamActions: TurboStreamActions) {
  streamActions.refresh_data_grid = refresh_data_grid;
}
